import React from "react"
import {Field} from "react-final-form";
import TextFieldWrapper from "../../Form/TextField";
import {useTranslation} from "react-i18next";

const EmailField = () => {
    const { t } = useTranslation()

    const validate = {
        email: (item: string | null) => {
            if (item)
                return !new RegExp(/^\S+@\S+\.\S+$/).test(item)
                    ? t('errors.email')
                    : ''
            return t('errors.required')
        },
    }

    return (
        <Field
            name="email"
            type="email"
            validate={validate.email}
        >
            {(props) => (
                <TextFieldWrapper
                    {...props}
                    fullWidth
                    variant="outlined"
                    required
                    placeholder={t('common.email')}
                />
            )}
        </Field>
    )
}

export default EmailField
